<app-layout type="blue">
  <div id="magic-link">
    <h1>{{ 'magicLink.title' | translate }}</h1>
    <app-icon-title-underline />

    @if (loading) {
    <app-spinner></app-spinner>
    } @else if (error) {
    <div class="error-message">
      <app-icon-warning />&nbsp;
      {{ error }}
    </div>
    <app-button variant="accent">
      <button type="button" data-testid="magic-link-retry" (click)="sendLink()">{{ 'magicLink.retry' | translate }}</button>
    </app-button>
    } @else if (sent) {
    <p data-testid="magic-link-sent">{{ 'magicLink.description' | translate: { email: email } }}</p>
    <app-button variant="secondary">
      <button type="button" data-testid="magic-link-resend" (click)="sendLink()">{{ 'magicLink.resend' | translate }}</button>
    </app-button>
    }

    <div class="back">
      <a routerLink="/" queryParamsHandling="preserve">{{ 'magicLink.back' | translate }}</a>
    </div>
  </div>
</app-layout>
